export const ENDPOINT_REPORT_BY_STATUS = '/api/report/by-status';
export const ENDPOINT_REPORT_BY_REGION = '/api/report/by-region';
export const ENDPOINT_REPORT_BY_YEAR = '/api/report/by-year';
